import { ScanFailureReason } from '@wix/a11y-wizard-common';
import { BiModalTypes, ErrorTooltipTypes } from './types';
const TOOLTIP_NAME_MAP = {
  [ScanFailureReason.DOMAIN_UNREACHABLE]: ErrorTooltipTypes.DomainUnreachable,
  [ScanFailureReason.SITE_DELETED]: ErrorTooltipTypes.SiteDeleted,
  [ScanFailureReason.NO_PAGES_FOUND]: ErrorTooltipTypes.NoPagesFound,
  [ScanFailureReason.PAGE_SERVER_ERROR]: ErrorTooltipTypes.PageServerError,
  [ScanFailureReason.PAGE_ACCESS_DENIED]: ErrorTooltipTypes.PageAccessDenied,
  [ScanFailureReason.PAGE_LOAD_TIMEOUT]: ErrorTooltipTypes.PageLoadTimeout,
  [ScanFailureReason.INTERNAL_ERROR]: ErrorTooltipTypes.InternalError,
  [ScanFailureReason.SCAN_TIMEOUT]: ErrorTooltipTypes.ScanTimeout
};
const MODAL_TYPE_MAP = {
  [ScanFailureReason.DOMAIN_UNREACHABLE]: BiModalTypes.DomainUnreachable,
  [ScanFailureReason.SITE_DELETED]: BiModalTypes.SiteDeleted,
  [ScanFailureReason.NO_PAGES_FOUND]: BiModalTypes.NoPageFound,
  [ScanFailureReason.PAGE_SERVER_ERROR]: BiModalTypes.GenericError,
  [ScanFailureReason.PAGE_ACCESS_DENIED]: BiModalTypes.GenericError,
  [ScanFailureReason.PAGE_LOAD_TIMEOUT]: BiModalTypes.GenericError,
  [ScanFailureReason.INTERNAL_ERROR]: BiModalTypes.GenericError,
  [ScanFailureReason.SCAN_TIMEOUT]: BiModalTypes.ScanTimeout
};
export function getErrorTooltipName(reason) {
  return reason ? TOOLTIP_NAME_MAP[reason] ?? ErrorTooltipTypes.GenericError : ErrorTooltipTypes.GenericError;
}
export function getErrorModalType(reason) {
  return reason ? MODAL_TYPE_MAP[reason] ?? BiModalTypes.GenericError : BiModalTypes.GenericError;
}
//# sourceMappingURL=scan-failure-bi-mapping.js.map